import { render, staticRenderFns } from "./index.vue?vue&type=template&id=13a9a360&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=13a9a360&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a9a360",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13a9a360')) {
      api.createRecord('13a9a360', component.options)
    } else {
      api.reload('13a9a360', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=13a9a360&scoped=true", function () {
      api.rerender('13a9a360', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/WMS/waveDetail/index.vue"
export default component.exports